import React from "react";
import { observer } from "mobx-react";
import { Button } from "src/components/ui/Button";
import GettingStarted1Img from "../../../assets/images/GettingStarted2.png";
import PlatoFooter from "../../../assets/images/PlatoFooter.png";
import { useTranslation } from "react-i18next";
import { useClientBranding } from "src/hooks/useClientBranding";
import { useFooterLogo } from "src/hooks/useFooterLogo";

const VerifyCard = observer(function VerifyCard({
  title = "Getting Started",
  description = "We need some information to help us confirm your identity",
  buttonText = "Begin Verifying",
  onButtonClick,
}) {
  const { t } = useTranslation();
  const branding = useClientBranding();
  const footerLogoUrl = useFooterLogo();
  /** Orta illüstrasyon her zaman Plato varsayılanı; settings logosu yalnızca alt footer’da */
  const heroSrc = GettingStarted1Img;
  const footerLogoSrc = footerLogoUrl || PlatoFooter;
  const footerLogoClasses = footerLogoUrl
    ? "max-h-12 w-auto max-w-[min(240px,100%)] object-contain object-center"
    : "";
  const textColor = branding?.layoutShellStyle?.color;

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="min-h-0 flex-1 overflow-y-auto overflow-x-hidden overscroll-y-contain">
        <div className="w-full pt-[10px]">
          <div>
            <div className="text-h5 font-bold mb-2 text-flow-heading">
              {title}
            </div>
            <div
              className={`text-body ${textColor ? "" : "text-flow"}`}
              style={textColor ? { color: textColor } : undefined}
            >
              {description}
            </div>
          </div>
          <figure className="mx-auto mt-2 h-[clamp(180px,30dvh,260px)] w-full max-w-[320px]">
            <img
              className="h-full w-full object-contain"
              src={heroSrc}
              alt={t("common.gettingStarted")}
            />
          </figure>
          <div>
            <div
              className={`text-xxs ${textColor ? "" : "text-Gray900"}`}
              style={textColor ? { color: textColor } : undefined}
            >
              {t("gettingStarted.policyConsent")}
            </div>
            <div>
              <Button
                onClick={onButtonClick}
                className="mt-4 font-bold"
                variant="primaryWithoutIcon"
              >
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </div>

      <footer
        className="shrink-0 w-full rounded-t-[16px]  bg-[color:var(--flow-accent-muted)] px-5 pt-4 pb-[calc(1.25rem+env(safe-area-inset-bottom,0px))] shadow-[inset_0_1px_0_0_rgba(255,255,255,0.65),0_8px_28px_-8px_rgb(15_23_42/0.12)]"
      >
        {!footerLogoUrl && (
          <div className="text-xxs text-flow-muted">{t("gettingStarted.securedWith")}</div>
        )}
        <div
          className={`text-h6 text-flow flex justify-center ${footerLogoUrl ? "" : "mt-1"}`}
        >
          <img
            width={100}
            height={100}
            src={footerLogoSrc}
            alt=""
            className={footerLogoClasses}
          />
        </div>
      </footer>
    </div>
  );
});

export default VerifyCard;
